<template>
    <div class="animated fadeIn">
        <kgr-note-box
            text-key="childParentIncome.tooltip"
            class="kgr-row"
        />

        <kgr-child-parent-incomes-data-provider
            v-slot="childParentIncomeScope"
            :child-id="childId"
        >
            <div>
                <kgr-empty-data
                    v-if="childParentIncomeScope.data.length === 0"
                    :value="$t('Es wurde noch keine Einkommenstabelle angelegt')"
                />

                <kgr-child-parent-incomes-list
                    v-else
                    :child-parent-incomes="childParentIncomeScope.data"
                    :child-id="childId"
                />
            </div>
        </kgr-child-parent-incomes-data-provider>
    </div>
</template>

<script>
import ChildParentIncomesDataProvider from '../../components/data-provider/ChildParentIncomesDataProvider';
import ChildParentIncomesList from '../../components/child/child-parent-income/ChildParentIncomesList';
import EmptyData from '../../components/common/EmptyData';
import NoteBox from '../../components/common/NoteBox';

export default {
    components: {
        'kgr-child-parent-incomes-data-provider': ChildParentIncomesDataProvider,
        'kgr-child-parent-incomes-list': ChildParentIncomesList,
        'kgr-empty-data': EmptyData,
        'kgr-note-box': NoteBox,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            childParentIncomes: Array,
        };
    },
    methods: {
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
